export enum FeatureFlags {
  AmazonOrdersView = 'amazon_orders_view',
  HealthDataReports = 'health_data_reports',
  OnboardingExperience = 'onboarding_experience',
  ActionGoalsEnabled = 'hp_action_goals_enabled'
}
